import logger from '@/utils/logger'

export default async function ({ store, redirect, route }) {
  // Проверяем авторизацию через токены
  const hasTokens =
    localStorage.getItem('accessToken') && localStorage.getItem('refreshToken')
  if (!hasTokens) {
    // Только если мы еще не на странице авторизации
    if (route.path !== '/auth') {
      return redirect('/auth')
    }
    return
  }

  try {
    await store.dispatch('auth/getUser')
  } catch (error) {
    logger.error('Ошибка проверки роли emp через /me:', error)
    store.commit('auth/clearTokens')
    if (route.path !== '/auth') {
      return redirect('/auth')
    }
    return
  }

  const user = store?.state?.auth?.user

  // Проверяем, есть ли роль emp
  if (!user || !Array.isArray(user?.roles) || !user.roles.includes('emp')) {
    // Редиректим на главную только если мы не на главной странице
    if (route.path !== '/') {
      return redirect('/')
    }
  }
}
